import { Facebook, MessageCircle, Phone, Mail } from "lucide-react";
import { BUSINESS, LOGOS, SERVICES, BRANCHES } from "@/data/cybernet";

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white pt-20 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="lg:col-span-4">
            <div className="mb-6">
              <div className="inline-flex items-center bg-white rounded-md px-3 py-2.5">
                <img src={LOGOS.mark} alt="CYBERNET" className="h-9 w-auto" />
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-6 max-w-sm">
              20 años ofreciendo tecnología, trámites digitales, servicio
              técnico y papelería en Cortazar, Gto.
            </p>
            <div className="flex gap-3">
              <a
                href={`https://wa.me/${BUSINESS.primaryWhatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-wa"
                className="h-10 w-10 rounded-sm bg-[#E10600] flex items-center justify-center hover:scale-110 transition-transform"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-4 w-4" />
              </a>
              <a
                href={BUSINESS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-fb"
                className="h-10 w-10 rounded-sm border border-white/20 flex items-center justify-center hover:border-[#E10600] hover:text-[#E10600] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={`tel:+${BUSINESS.primaryWhatsapp}`}
                data-testid="footer-call"
                className="h-10 w-10 rounded-sm border border-white/20 flex items-center justify-center hover:border-[#E10600] hover:text-[#E10600] transition-colors"
                aria-label="Llamar"
              >
                <Phone className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-[#E10600] font-bold mb-4">
              Navegación
            </h4>
            <ul className="space-y-3 text-sm">
              {["servicios", "nosotros", "catalogo", "sucursales", "contacto"].map(
                (id) => (
                  <li key={id}>
                    <button
                      onClick={() => scrollTo(id)}
                      className="text-white/70 hover:text-white capitalize"
                    >
                      {id === "catalogo" ? "Catálogo" : id}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-[#E10600] font-bold mb-4">
              Servicios
            </h4>
            <ul className="space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.id} className="text-white/70">
                  {s.title}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-[#E10600] font-bold mb-4">
              Contacto
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 shrink-0 mt-0.5 text-[#E10600]" />
                <div>
                  {BRANCHES.map((b) => (
                    <div key={b.id}>
                      <span className="font-semibold text-white/90">
                        {b.name.replace("CYBERNET ", "").replace("CYBERCLIC ", "")}:
                      </span>{" "}
                      {b.phone}
                    </div>
                  ))}
                </div>
              </li>
              <li className="flex items-center gap-2 pt-2">
                <Mail className="h-4 w-4 text-[#E10600]" />
                {BUSINESS.email}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>
            © {new Date().getFullYear()} CYBERNET Cortazar. Todos los derechos
            reservados.
          </p>
          <p>Cortazar, Guanajuato · México</p>
        </div>
      </div>
    </footer>
  );
};
